export const AccountTypes = [{ title: "All", id: 1, value: '-1' }, { title: "Member", id: 2, value: 'member' }, { title: "Not a Member", id: 3, value: 'non-member' }, { title: "Organization", id: 4, value: 'organization' }]
export const GenderData = [{ title: "Male", id: 1 }, { title: "Female", id: 2 }, { title: "Other", id: 3 }]
export const StatusData = [{ title: "Single", id: 1 }, { title: "Married", id: 2 }]
export const ReligionData = [{ title: "Jewish", id: 1 }, { title: "Converting", id: 2 }, { title: "Other", id: 3 }]
export const RelationshipData = [
    { title: "Parent-1", id: 1 },
    { title: "Parent-2", id: 2 },
    { title: "Parent-3", id: 3 },
    { title: "Adult-1", id: 4 },
    { title: "Adult-2", id: 5 },
    { title: "Adult-3", id: 6 },
    { title: "Child", id: 7 },
    { title: "Father", id: 8 },
    { title: "Mother", id: 9 },
    { title: "Brother", id: 10 },
    { title: "Sister", id: 11 },
    { title: "Wife", id: 12 },
    { title: "Husband", id: 13 },
    { title: "Father-in-law", id: 14 },
    { title: "Mother-in-law", id: 15 },
    { title: "Brother-in-law", id: 16 },
    { title: "Sister-in-law", id: 17 },
    { title: "Uncle", id: 18 },
    { title: "Aunt", id: 19 },
    { title: "Nephew", id: 20 },
    { title: "Niece", id: 21 },
    { title: "Grandmother", id: 22 },
    { title: "Grandfather", id: 23 },
    { title: "Great-grandmother", id: 24 },
    { title: "Great-grandfather", id: 25 },
    { title: "Cousin", id: 26 },
    { title: "Friend", id: 27 },
    { title: "Grandson", id: 28 },
    { title: "Granddaughter", id: 29 },
    { title: "Son-in-Law", id: 30 },
    { title: "Daughter-in-Law", id: 31 },
    { title: "Other", id: 32 },
];